module.exports = __webpack_public_path__ + "img/11.752f0959.png";